import { ReactNode } from 'react';
import {
  MBox,
  MHeading,
  MPageContainer,
  MText,
} from '../../components/Monetize';

interface ExternalShareErrorPageProps {
  /**
   * The title to display on the error page.
   */
  title: string;
  /**
   * Optional description, it is recommended to provide a description
   */
  description?: string;
  /**
   * Optional additional content to render below the title and description.
   */
  children?: ReactNode;
}

export const ExternalShareErrorPage = ({
  title,
  description,
  children,
}: ExternalShareErrorPageProps) => {
  return (
    <MPageContainer>
      <MBox
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
        flex={1}
      >
        <MHeading fontSize="3xl" mb="3">
          {title}
        </MHeading>
        {description && <MText fontSize="lg">{description}</MText>}
        {children}
      </MBox>
    </MPageContainer>
  );
};
